import { render, staticRenderFns } from "./ModalPreloader.vue?vue&type=template&id=5d86b090&lang=pug&"
import script from "./ModalPreloader.vue?vue&type=script&lang=js&"
export * from "./ModalPreloader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports